// extracted by mini-css-extract-plugin
module.exports = {"container":"Ce","copy":"De","field":"Ee","error":"Fe","disabled":"Ge","termsContainer":"He","termsHeading":"Ie","termsCopy":"Je","submit":"Ke","srOnly":"Le"};